import _classCallCheck from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/gongwu.nie/Github/react-base-table/website/node_modules/@babel/runtime/helpers/esm/inherits";
import { TokenType as tt } from "../parser/tokenizer/types";
import Transformer from "./Transformer";

var OptionalCatchBindingTransformer =
/*#__PURE__*/
function (_Transformer) {
  _inherits(OptionalCatchBindingTransformer, _Transformer);

  function OptionalCatchBindingTransformer(tokens, nameManager) {
    var _this;

    _classCallCheck(this, OptionalCatchBindingTransformer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OptionalCatchBindingTransformer).call(this));
    _this.tokens = tokens;
    _this.nameManager = nameManager;
    ;
    return _this;
  }

  _createClass(OptionalCatchBindingTransformer, [{
    key: "process",
    value: function process() {
      if (this.tokens.matches2(tt._catch, tt.braceL)) {
        this.tokens.copyToken();
        this.tokens.appendCode(" (".concat(this.nameManager.claimFreeName("e"), ")"));
        return true;
      }

      return false;
    }
  }]);

  return OptionalCatchBindingTransformer;
}(Transformer);

export { OptionalCatchBindingTransformer as default };